var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSticky(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.375 -9.375) scale(1.1250)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.8201 21H22.6001C22.04 21 21.76 21 21.5461 21.109C21.3579 21.2049 21.2049 21.3578 21.1091 21.546C21.0001 21.7599 21.0001 22.0399 21.0001 22.6V26.82M27 19.7269V14.2C27 13.0799 27 12.5198 26.782 12.092C26.5903 11.7157 26.2843 11.4097 25.908 11.218C25.4802 11 24.9201 11 23.8 11H14.2C13.0799 11 12.5198 11 12.092 11.218C11.7157 11.4097 11.4097 11.7157 11.218 12.092C11 12.5198 11 13.0799 11 14.2V23.8C11 24.9201 11 25.4802 11.218 25.908C11.4097 26.2843 11.7157 26.5903 12.092 26.782C12.5198 27 13.0799 27 14.2 27H19.9496C20.4578 27 20.7118 27 20.9498 26.9407C21.1608 26.8882 21.3618 26.8016 21.5449 26.6844C21.7515 26.5522 21.926 26.3675 22.2751 25.9983L26.1254 21.9252C26.4486 21.5833 26.6101 21.4124 26.7255 21.2156C26.8278 21.041 26.903 20.8519 26.9486 20.6548C27 20.4325 27 20.1973 27 19.7269Z",
    stroke: "currentColor",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticky);
export default __webpack_public_path__ + "static/media/sticky.e4c299da39eb3532b0fabdadbeff75b1.svg";
export { ForwardRef as ReactComponent };